module.exports = __webpack_public_path__ + "static/media/Linkedin-Icon.2ecee908.png";